import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function BuyAndSellStock({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/StockFactors");
    };

    const goPrev = () => {
        navigate("/StockDef");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Buying And Selling Stocks
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-3">
                    A person or firm who buys and/or sells stocks on the behalf of an investor is
                </div>
                <div className="text-[#000000] text-3xl">
                    called a stockbroker.  Generally, people will use a stockbroker to buy and sell
                </div>
                <div className="text-[#000000] text-3xl">
                    stocks, and the stockbroker takes a cut of the profit as a commission.
                </div>
                <div className="text-[#000000] text-3xl mt-3">
                    To make a profit from stocks, you can hold the stock long enough for the
                </div>
                <div className="text-[#000000] text-3xl">
                    stock to pay back your investment.  A portion of a company’s earnings are given
                </div>
                <div className="text-[#000000] text-3xl">
                    to each shareholder depending on how many shares the holder has.
                </div>
                <div className="text-[#000000] text-3xl mt-3">
                    Another way is to buy stocks when they are at a low price and sell them when
                </div>
                <div className="text-[#000000] text-3xl">
                    they are worth more.
                </div>
            </div>
            <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                onClick={goNext}
            >
                Next
            </button>
            <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                onClick={goPrev}
            >
                Prev
            </button>
        </div>
    );
}